import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'reactstrap';

import styles from 'styles/Calendar.module.scss';
import { USER_METHODS } from '../../../../constants/constants';
import { useSelector } from 'react-redux';
import { getColor, getColorText } from 'store/settings';

const FooterAdmin = ({
  onEdit,
  onStartRoom,
  isStart,
  renderRecorded,
  isDisabled,
}) => {
  //Color Theme
  const colorStatus = useSelector(getColor);
  const colorTextStatus = useSelector(getColorText);
  return (
    <div
      className={classnames(
        styles.popoverFooter,
        'd-flex justify-content-between',
      )}
    >
      {renderRecorded()}
      <button
        className="btn-bg-color"
        onClick={onEdit}
        permission={[USER_METHODS.PUT, 'user-events/:id']}
        style={{
          backgroundColor: `${colorStatus}`,
          color: `${colorTextStatus}`,
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'white';
          e.target.style.borderColor = colorStatus;
          e.target.style.color = colorStatus;
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = colorStatus;
          e.target.style.color = colorTextStatus;
        }}
      >
        Edit
      </button>

      <div className="d-flex align-items-center">
        {isStart && (
          <button
            className="btn-bg-color"
            disabled={!isDisabled}
            onClick={onStartRoom}
            style={{
              backgroundColor: `${colorStatus}`,
              color: `${colorTextStatus}`,
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.borderColor = colorStatus;
              e.target.style.color = colorStatus;
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = colorStatus;
              e.target.style.color = colorTextStatus;
            }}
          >
            Start Room
          </button>
        )}
      </div>
    </div>
  );
};

FooterAdmin.propTypes = {
  onStartRoom: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  isStart: PropTypes.bool.isRequired,
  renderRecorded: PropTypes.func.isRequired,
};

export default FooterAdmin;
